import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useForm, FormContext } from "react-hook-form";
import {
  Grid,
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import useStyles from "../../../../themes/makeStyles";
import clsx from "clsx";
import SkeletonComponent from "../../../../components/SkeletonComponent";
import DatePicker from "../../../../components/DateComponent";
import Autocomplete from "../../../../components/AutoComplete";
import PickListOptions from "../../../../constants/PickListOptions";
import moment from "moment";

export default function CreateWagonSchedule(props) {
  const classes = useStyles();
  const [tableData, setTableData] = useState([]);
  // const [depoNameOptions, setDepoNameOptions] = useState([]);
  // const [rakeStatusOptions, setRakeStatusOptions] = useState([]);
  const [wagonMasterListMainDataList, setWagonMasterListMainDataList] =
    useState([]);
  const [rohPohMasterList, setRohPohMasterList] = React.useState([]);
  const [scheduleType, setScheduleType] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [selectedRakeType, setSelectedRakeType] = React.useState("");
  const [actualDateOfDeparture, setActualDateOfDeparture] = React.useState("");
  const [expectedDateOfDeparture, setExpectedDateOfDeparture] =
    React.useState("");
  const [arrivalAtBase, setArrivalAtBasePohDepot] = React.useState("");
  const [moveWithStatusOptions, setMoveWithStatusOption] = React.useState([]);
  const { control, errors, handleSubmit, setValue, reset } = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    submitFocusError: true,
    defaultValues: {
      wagon_number: "",
      planned_roh_poh_date: undefined,
      actual_roh_poh_date: undefined,
      expected_date_of_departure: undefined,
      actual_date_of_departure: undefined,
      diff_date: "",
      status: "",
    },
  });

  const defaultValues = {
    wagon_number: "",
    planned_roh_poh_date: undefined,
    actual_roh_poh_date: undefined,
    expected_date_of_departure: undefined,
    actual_date_of_departure: undefined,
    diff_date: "",
    status: "",
  };
  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    submitFocusError: true,
    defaultValues,
  });

  const [isEdit, setIsEdit] = useState(props.location.isEdit);

  const tableHeader = useMemo(
    () => [
      { id: "slNo", label: "Sl No" },
      { id: "wagonNo", label: "Wagon No" },
      { id: "plannedRohPohDate", label: `Planned ${scheduleType} Date` },
      { id: "actualRohPohDate", label: `Actual ${scheduleType} Date` },
      // { id: "expectedDateOfDeparture", label: "Expected Date of Departure" },
      { id: "actualDateOfDeparture", label: "Actual Date of Departure" },
      { id: "diffDate", label: "Difference Date" },
      { id: "wagonStatus", label: "Wagon Status" },
      { id: "movedWith", label: "Moved With" },
    ],
    [scheduleType],
  );

  useEffect(() => {
    console.log("CreateWagonSchedule useEffect", props, tableData.length);

    setMoveWithStatusOption(PickListOptions.MOVED_WITH_SCHEDULE_OPTIONS);

    // Update state from props only if changed
    if (props.scheduleType && scheduleType !== props.scheduleType) {
      setScheduleType(props.scheduleType);
    }
    if (props.selectedRakeType && selectedRakeType !== props.selectedRakeType) {
      setSelectedRakeType(props.selectedRakeType);
    }
    if (
      props.wagonMasterListMainDataList?.length &&
      wagonMasterListMainDataList !== props.wagonMasterListMainDataList
    ) {
      setWagonMasterListMainDataList(props.wagonMasterListMainDataList);
    }
    if (
      props.rohPohMasterList?.length &&
      rohPohMasterList !== props.rohPohMasterList
    ) {
      setRohPohMasterList(props.rohPohMasterList);
    }

    if (props.actualDateOfDeparture) {
      setActualDateOfDeparture(
        formatDate(new Date(props.actualDateOfDeparture)),
      );
    } else {
      setActualDateOfDeparture(undefined);
    }

    if (props.arrivalAtBasePohDepot) {
      setArrivalAtBasePohDepot(
        formatDate(new Date(props.arrivalAtBasePohDepot)),
      );
    }

    // Calculate planned dates when required props are available
    if (
      props.scheduleType &&
      props.wagonMasterListMainDataList?.length &&
      props.rohPohMasterList?.length &&
      props.selectedRakeType
    ) {
      console.log(
        "Updating table data based on props",
        wagonMasterListMainDataList,
        scheduleType,
        rohPohMasterList,
        selectedRakeType,
      );
      setLoading(true);

      const rohFilter = props.rohPohMasterList.filter(
        (ele) => ele.wagon_type === props.selectedRakeType,
      );
      const rohPohConfig = rohFilter.length ? rohFilter[0] : {};

      const diffDay = calculateDiff(
        props.expectedDateofDeparture,
        props.actualDateOfDeparture,
      );
      console.log("diffDay: ", diffDay);

      // const todayDate = new Date();
      const updatedTableData = props.wagonMasterListMainDataList.map(
        (row, i) => {
          if (row.rake_build_date) {
            try {
              const wagonBuildDate = new Date(row.rake_build_date);
              if (isNaN(wagonBuildDate.getTime())) {
                throw new Error("rake_build_date");
              }

              const firstYearMonths =
                props.scheduleType === "ROH"
                  ? rohPohConfig.roh_schedule_first_year
                  : rohPohConfig.poh_schedule_first_year;

              const subsequentYearMonths =
                props.scheduleType === "ROH"
                  ? rohPohConfig.roh_schedule_subsequent_year
                  : rohPohConfig.poh_schedule_subsequent_year;

              if (
                firstYearMonths === undefined ||
                subsequentYearMonths === undefined ||
                firstYearMonths < 0 ||
                subsequentYearMonths < 0
              ) {
                throw new Error("config_missing");
              }

              // Base date for calculation
              const baseDate =
                props.scheduleType === "ROH"
                  ? row.roh_date
                    ? new Date(row.roh_date)
                    : wagonBuildDate
                  : row.poh_date
                    ? new Date(row.poh_date)
                    : wagonBuildDate;

              if (isNaN(baseDate.getTime())) {
                throw new Error("invalid_base_date");
              }

              const copyBaseDate = new Date(baseDate);
              let plannedDate;

              if (props.scheduleType === "POH") {
                // POH Logic: if row.poh_date is null then FirstYear else SubsequentYear
                if (!row.poh_date) {
                  const firstCycleDate = new Date(copyBaseDate);
                  firstCycleDate.setMonth(
                    firstCycleDate.getMonth() + firstYearMonths,
                  );
                  plannedDate = getPlannedMonthEnd(firstCycleDate);

                  if (!plannedDate || isNaN(new Date(plannedDate).getTime())) {
                    throw new Error("poh_first_year_failed");
                  }
                } else {
                  const subsequentCycleDate = new Date(copyBaseDate);
                  subsequentCycleDate.setMonth(
                    subsequentCycleDate.getMonth() + subsequentYearMonths,
                  );
                  plannedDate = getPlannedMonthEnd(subsequentCycleDate);
                  if (!plannedDate || isNaN(new Date(plannedDate).getTime())) {
                    throw new Error("poh_subsequent_year_failed");
                  }
                }
              } else {
                // ROH Logic: if row.wagon_roh_count < ROHCount then FirstYear else SubsequentYear
                const ROHCount = Math.floor(
                  rohPohConfig.poh_schedule_first_year /
                  (rohPohConfig.roh_schedule_first_year || 1),
                );

                if (row.wagon_roh_count < ROHCount && !row.poh_date) {
                  const firstCycleDate = new Date(copyBaseDate);
                  firstCycleDate.setMonth(
                    firstCycleDate.getMonth() + firstYearMonths,
                  );
                  plannedDate = getPlannedMonthEnd(firstCycleDate);
                  if (!plannedDate || isNaN(new Date(plannedDate).getTime())) {
                    throw new Error("roh_first_year_failed");
                  }
                } else {
                  const subsequentCycleDate = new Date(copyBaseDate);
                  subsequentCycleDate.setMonth(
                    subsequentCycleDate.getMonth() + subsequentYearMonths,
                  );
                  plannedDate = getPlannedMonthEnd(subsequentCycleDate);
                  if (!plannedDate || isNaN(new Date(plannedDate).getTime())) {
                    throw new Error("roh_subsequent_year_failed");
                  }
                }
              }

              const formattedDate = formatDate(plannedDate);
              if (!formattedDate) {
                throw new Error("format_failed");
              }

              row.planned_roh_poh_date = formattedDate;
            } catch (error) {
              // Professional user notifications - NO technical details
              let message = "";

              switch (error.message) {
                case "rake_build_date":
                  message = "Please enter a valid Rake Build Date";
                  break;

                case "config_missing":
                  message = `${props.scheduleType} Schedule configuration missing. ROH POH Schedule Master not found for Rake type - ${props.selectedRakeType}`;
                  break;

                case "invalid_base_date":
                  message =
                    props.scheduleType === "ROH"
                      ? `Invalid ROH Date or Rake Build Date Found - ${row.roh_date}`
                      : `Invalid POH Date or Rake Build Date Found - ${row.poh_date}`;
                  break;

                case "poh_first_year_failed":
                case "poh_subsequent_year_failed":
                  message =
                    "POH Planned Date calculation failed. Verify dates.";
                  break;

                case "roh_first_year_failed":
                case "roh_subsequent_year_failed":
                  message =
                    "ROH Planned Date calculation failed. Verify dates and ROH count.";
                  break;

                case "format_failed":
                  message = "Date formatting error. Please refresh and retry.";
                  break;

                default:
                  message = `Unable to calculate ${props.scheduleType} Planned Date. Check date fields.`;
              }

              props.setNotify({
                isOpen: true,
                message: message,
                type: "error",
                timing: 5000,
              });
            }
          } else {
            props.setNotify({
              isOpen: true,
              message:
                "Please fill Rake Build Date to calculate planned schedule",
              type: "warning",
              timing: 4000,
            });
          }

          return {
            id: i,
            wagon_number: row.wagon_number,
            planned_roh_poh_date: row.planned_roh_poh_date || "",
            actual_roh_poh_date: row.actual_roh_poh_date || undefined,
            expected_date_of_departure: row.expected_date_of_departure,
            actual_date_of_departure: props.actualDateOfDeparture
              ? formatDate(new Date(props.actualDateOfDeparture))
              : "",
            diff_date: String(diffDay) || "",
            status: row.actual_roh_poh_date ? "Done" : "Due",
            move_with:
              row.move_with ||
              PickListOptions.MOVED_WITH_SCHEDULE_OPTIONS[0].value,
          };
        },
      );

      setTableData(updatedTableData);

      if (props.onSubmitLastComposition) {
        props.onSubmitLastComposition(updatedTableData);
      }

      setLoading(false);
    }
  }, [
    props.scheduleType,
    props.wagonMasterListMainDataList,
    props.actualDateOfDeparture,
    props.expectedDateOfDeparture,
    props.rohPohMasterList,
    props.arrivalAtBasePohDepot,
    props.expectedDateofDeparture,
  ]);

  // utils
  const getPlannedMonthEnd = (date) => {
    const d = new Date(date); // copy, don't mutate caller
    const day = d.getDate();
    const addMonths = day < 25 ? 1 : 2;

    // move to target month (handles year rollover) [web:57][web:62]
    d.setMonth(d.getMonth() + addMonths);

    // last day of that target month: day 0 of next month [web:58][web:63]
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
  };

  const calculateDiff = (expectedDateOfDeparture, actualDateOfDeparture) => {
    console.log(
      "expectedDateOfDeparture, actualDateOfDeparture: ",
      expectedDateOfDeparture,
      actualDateOfDeparture,
    );
    if (!expectedDateOfDeparture || !actualDateOfDeparture) {
      props.setNotify({
        isOpen: true,
        message: `Please fill Expected Date of Formation / Departure Date Time From Base/POH Depot`,
        type: "warning",
        timing: 2000,
      });
      return 0;
    }

    const d1 = new Date(expectedDateOfDeparture);
    const d2 = new Date(actualDateOfDeparture);

    // Normalize to midnight to avoid time issues
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    const diffInMs = d2.getTime() - d1.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    console.log("Difference in days:", diffInDays);
    return diffInDays;
  };

  const handleFieldChange = useCallback(
    (id, field, value) => {
      console.log(id, field, value);
      setLoading(true);
      setTableData((prevData) => {
        const updatedData = [...prevData];
        const rowIndex = updatedData.findIndex((row) => row.id === id);
        if (rowIndex !== -1) {
          if (field === "actual_roh_poh_date") {
            updatedData[rowIndex][field] = formatDate(new Date(value));
            updatedData[rowIndex]["status"] = value ? "Done" : "Due";
          } else {
            updatedData[rowIndex][field] = value; // Modify the specific field
          }
        }
        return updatedData;
      });
      if (props.onSubmitLastComposition) {
        props.onSubmitLastComposition(tableData); // Send data to parent
      }
      setLoading(false);
    },
    [props],
  );

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  };

  const TableHeadList = () => (
    <TableHead>
      <TableRow>
        {tableHeader.map((thead, index) => (
          <TableCell key={index}>{thead.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );

  const TableDataList = () => (
    <TableBody>
      {tableData.map((row, index) => (
        <TableRow key={row.id}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>{row.wagon_number}</TableCell>
          <TableCell>{row.planned_roh_poh_date}</TableCell>
          <TableCell>
            <DatePicker
              name={`tableData[${index}].actual_roh_poh_date`}
              control={methods.control}
              disabled={false}
              error={errors[`actual_roh_poh_date`]}
              defaultValue={tableData[index]?.actual_roh_poh_date}
              id={tableData[index].actual_roh_poh_date}
              getValueChanged={(data) => {
                handleFieldChange(row.id, "actual_roh_poh_date", data);
              }}
            />
          </TableCell>
          {/* <TableCell>{row.expected_date_of_departure}</TableCell> */}
          <TableCell>{row.actual_date_of_departure}</TableCell>
          <TableCell
            style={{ backgroundColor: row.diff_date < 0 ? "green" : "yellow" }}
          >
            {row.diff_date}
          </TableCell>
          <TableCell>{row.status}</TableCell>
          <TableCell>
            <Autocomplete
              name={`tableData[${index}].move_with`}
              defaultValue={row.move_with}
              control={control}
              Values={moveWithStatusOptions}
              getValueChanged={(value) =>
                handleFieldChange(row.id, "move_with", value.value)
              }
              error={errors[`move_with`]}
              label="Move With"
              disabled={false}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );

  const prepareDataForSubmit = () => {
    const tableDataToSend = tableData.map((row) => ({
      wagon_number: row.wagon_number,
      planned_roh_poh_date: row.planned_roh_poh_date,
      actual_roh_poh_date: row.actual_roh_poh_date,
      expected_date_of_departure: row.expected_date_of_departure,
      actual_date_of_departure: row.actual_date_of_departure,
      diff_date: row.diff_date,
      status: row.status,
      move_with: row.move_with,
    }));

    return { tableData: tableDataToSend };
  };

  const onSubmitLastComposition = () => {
    const dataToSend = prepareDataForSubmit();
    console.log("Form data: ", dataToSend, props);
    if (props.onSubmitLastComposition) {
      props.onSubmitLastComposition(dataToSend); // Send data to parent
    }
  };

  return (
    <FormContext {...methods}>
      <Box py={1}>
        <Paper elevation={0}>
          <Box p={3}>
            {/* <form noValidate id="commodity-master" onSubmit={handleSubmit(onSubmitLastComposition)}> */}
            <Typography variant="h6">Wagon wise schedule</Typography>
            <Box style={{ maxHeight: 500, overflowY: "auto" }}>
              <Table stickyHeader aria-label="sticky table">
                {loading ? (
                  <SkeletonComponent />
                ) : (
                  <>
                    <TableHeadList />
                    <TableDataList />
                  </>
                )}
              </Table>
            </Box>
          </Box>
        </Paper>
      </Box>
    </FormContext>
  );
}
